import React from 'react';
import Hero from './Hero';
import Services from './Services';
import Hosting from '../Hosting/Hosting';
import Why from './Why';
import Domain from '../Domain/Domain';
import Licenses from '../../Licenses';
import Testimonials from './Testimonials';
import Contact from './Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Services />
      <Hosting />
      <Why />
      <Domain />
      <Licenses />
      <Testimonials />
      <Contact />
    </>
  );
};

export default Home;
